import "../Css/Languages.css";
import React from "react";
import Flag from 'react-world-flags';


const languages = [
  { language: "Greek", proficiency: "Native", languageCode: "gr" },
  { language: "English", proficiency: "C2", languageCode: "usa" },
  { language: "German", proficiency: "B1", languageCode: "deu" },
];

const Languages = () => {

  return (

    <section className="mb-3" id="languages">

      <h2 className="section-title">
        <i className="fas fa-earth-europe"></i> <span style={{ marginLeft: "10px" }}>Languages</span>
      </h2>

      {
        languages.map((lang, index) => (

          <div key={index} className="language-item">

            <Flag className="language-flag" code={lang.languageCode} />

            <span className="language-name">{lang.language}</span>

            <span className="language-proficiency">{lang.proficiency}</span>

          </div>

        ))
      }

    </section>


  );

};

export default Languages;